<div class="grid">
  <div class="col-12">
    <app-loading *ngIf="loading"></app-loading>
    <div
      *ngIf="!loading"
      class="recuadro-widget"
      style="width: 100%; margin: 0; position: relative; overflow: hidden"
    >
      <!-- Etiqueta Nuevo -->
      <div class="cinta" *ngIf="funcionalidadWPECRZ && funcionalidadWPECRZ.nuevo">Nuevo</div>

      <div class="widget-title">
        {{ "WIDGETS.LBL_TITULOCLIENTECREZCAMOS" | translate }}
      </div>
      <div class="widget-contenido">
        <img
          src="../../../../../../assets/icons/perfil-crezcamos/icon-crezcamos.svg"
          alt="calculadora"
        />
        <span class="widget-subtitle">{{ "WIDGETS.LBL_SUBTITULOCLIENTECREZCAMOS" | translate }}</span>
      </div>
      <div style="display: flex">
        <button
          class="btns-acciones"
          label="{{ 'PERFILCREZCAMOS.LBL_CONSULTAR' | translate }}"
          type="button"
          pButton
          (click)="irPerfilCrecamos()"
        ></button>
      </div>
    </div>
  </div>
</div>
